module.exports = __webpack_public_path__ + "static/sprout-social-e91fa111b47c34af6212a11073f0f457.png";